import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./sticky_sales_cta.css";

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

const CACHED_OFFERS = {
  DEFAULT: {
    code: "DEFAULT",
    prices: {
      base: "397",
      credit_card: { 12: "38.91" },
      pix: "397",
    },
  },
  DEFAULT2: {
    code: "DEFAULT2",
    prices: {
      base: "197",
      credit_card: { 12: "19.31" },
      pix: "197",
    },
  },
};

const formatBRL = (value) => {
  const number = parseFloat(value);
  return number % 1 === 0
    ? number.toFixed(0)
    : number.toFixed(2).replace(".", ",");
};

/** Compact sticky bar shown once the visitor reaches the screenshots section. */
const StickySalesCta = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    const code = new URLSearchParams(location.search).get("o") ?? "DEFAULT";
    if (CACHED_OFFERS[code]) {
      setOffer(CACHED_OFFERS[code]);
      return undefined;
    }

    let cancelled = false;
    fetch(`${baseAPI_URL}/offers/get-offer/${code}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!cancelled && ok) setOffer(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [location.search]);

  useEffect(() => {
    let observer = null;
    let retryTimer = null;
    let cancelled = false;

    const hasReached = (el) => {
      // Show as soon as the section top enters (or passes) the viewport.
      return el.getBoundingClientRect().top <= window.innerHeight;
    };

    const onIntersect = ([entry]) => {
      setVisible(
        entry.isIntersecting || entry.boundingClientRect.top < 0
      );
    };

    const attach = () => {
      const screenshotsEl = document.getElementById("screenshots");
      if (!screenshotsEl) return false;

      observer = new IntersectionObserver(onIntersect, { threshold: 0 });
      observer.observe(screenshotsEl);
      setVisible(hasReached(screenshotsEl));
      return true;
    };

    if (!attach()) {
      retryTimer = setInterval(() => {
        if (cancelled) return;
        if (attach()) {
          clearInterval(retryTimer);
          retryTimer = null;
        }
      }, 100);
    }

    return () => {
      cancelled = true;
      if (retryTimer) clearInterval(retryTimer);
      if (observer) observer.disconnect();
    };
  }, []);

  if (!offer || !visible) return null;

  const instalment12x = formatBRL(offer.prices.credit_card[12]);

  return (
    <>
      <div className="sticky-sales-cta-spacer" aria-hidden="true" />
      <div className="sticky-sales-cta" role="region" aria-label="Oferta">
        <div className="sticky-sales-cta-inner">
          <div className="sticky-sales-cta-price">
            <span className="sticky-sales-cta-price-main">
              12x de R$ {instalment12x}
            </span>
            <span className="sticky-sales-cta-price-sub">
              ou R$ {formatBRL(offer.prices.pix)} no Pix
            </span>
          </div>
          <button
            type="button"
            className="sticky-sales-cta-btn"
            onClick={() => navigate(`/checkout${location.search}`)}
          >
            Quero meu acesso
          </button>
        </div>
      </div>
    </>
  );
};

export default StickySalesCta;
